import React from "react";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";

import {sendCommandFlex35} from "../../API/AcionamentoFlex35";
import {sendCommandFlex8} from "../../API/AcionamentoFlex8";

export class LightGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupId: props.groupId,
      className: props.className,
      descricao: props.descricao,
      imageUrl: props.imageUrl,
      onCommand: props.onCommand,
      offCommand: props.offCommand,
      x: props.x,
      y: props.y,
      width: props.width,
      height: props.height,
      imageState: this.convertToBoolean(props.imageState),
      lights: [],
    };
  }

  convertToBoolean(value) {
    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }
    return value;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imageState !== this.props.imageState) {
      this.setState({ imageState: this.convertToBoolean(this.props.imageState) });
      this.updateLightsState(this.convertToBoolean(this.props.imageState));
    }
  }

  updateLightsState = (newImageState) => {
    this.setState((prevState) => ({
      lights: prevState.lights.map((light) => ({
        ...light,
        imageState: newImageState,
      })),
    }));
  }

  toggleLights = () => {
    const newImageState = !this.state.imageState;
    this.setState({ imageState: newImageState });
    const action = newImageState ? this.state.onCommand : this.state.offCommand;
    this.sendCommand(this.state.descricao, action);

    // Atualiza o estado de todas as luzes no grupo
    this.updateLightsState(newImageState);
    this.props.onToggleLightGroup(this.state.groupId, newImageState);
  };

  sendCommand(descricao, action) {
    if (action.length === 4) {
      sendCommandFlex35(descricao, action);
    } else {
      sendCommandFlex8(descricao, action);
    }
  }



  render() {
    const { x, y, width, height, imageState, descricao, className } = this.state;
    const { groupId } = this.props;
    const style = {
      left: `${x}%`,
      top: `${y}%`,
      width: `${width}%`,
      height: `${height}%`,
      position: "absolute",
      cursor: "pointer",
    };
    const imgStyle = {
      position: "relative",
      width: "100%",
      height: "100%",
    };
  
    return (
      <div id={`group-${groupId}`} className={`LightGroup ${className}`} style={style} onClick={this.toggleLights}>
        <img
          id={groupId}
          className="imageLuz"
          src={imageState ? Ligado : Desligado}
          alt={descricao}
          style={imgStyle}
        />
        {this.state.lights.map((light, index) => (
          <div key={index} className="Light" style={style} onClick={this.toggleLights}>
            <img
              src={light.imageState ? Ligado : Desligado}
              alt={light.descricao}
              style={imgStyle}
            />
          </div>
        ))}
      </div>
    );
  }
}